/* npm version only adapted from https://github.com/yields/empty */
/**
 * Empty the given `el`.
 *
 * @param {Element} el
 * @return {Element}
 */

export default function(el, node) {
  while ((node = el.firstChild))
    el.removeChild(node);
  return el;
}



// WEBPACK FOOTER //
// ./src/modules/npm-component/empty.js